import { render, staticRenderFns } from "./InvoiceProducts.vue?vue&type=template&id=5279ea41&scoped=true"
import script from "./InvoiceProducts.vue?vue&type=script&lang=js"
export * from "./InvoiceProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279ea41",
  null
  
)

export default component.exports